import { render, staticRenderFns } from "./ViewVehicleContractComment.vue?vue&type=template&id=a261ef06&scoped=true"
import script from "./ViewVehicleContractComment.vue?vue&type=script&lang=ts"
export * from "./ViewVehicleContractComment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a261ef06",
  null
  
)

export default component.exports